import { RetencionDetalle } from "./retencionDetalle";

export class Retencion {
    id: number;
    fecha: Date;
    numeroRetencion: string;
    numeroComprobante: string;
    idCliente: number;
    idEmisor: number;
    mesContable:number;
    anioContable:number;
    autorizacion:string;
    ruta:string;
    error:string;
    usuario:string;
    establecimiento:string;
    detalle:RetencionDetalle[]=[]
    
    }

    